import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];

const DashboardStats = ({ domainStats, hourStats }) => {
  // Prepare chart data
  const domainData = Object.entries(domainStats).map(([domain, count]) => ({
    name: domain,
    value: count,
  }));

  const hourData = Object.entries(hourStats).map(([hour, count]) => ({
    hour: `${hour}:00`,
    leads: count,
  }));

  return (
    <div style={{ marginTop: "40px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>📊 Leads Analytics</h2>

      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}>
        <div style={{ width: "100%", maxWidth: "500px", margin: "20px" }}>
          <h3 style={{ textAlign: "center" }}>Leads per Email Domain</h3>
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={domainData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={100}
                fill="#8884d8"
                dataKey="value"
                label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
              >
                {domainData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div style={{ width: "100%", maxWidth: "600px", margin: "20px" }}>
          <h3 style={{ textAlign: "center" }}>Leads per Hour</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={hourData}>
              <XAxis dataKey="hour" />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="leads" fill="#4CAF50" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default DashboardStats;
